import { useApplicationCache } from '../../../../../../../../queries/useApplicationCache';

/**
 * Reads the total rent (sum of all unit rents) for a given property from the React Query application cache.
 * Shared by UnitInformationFooter and MobileUnitInformationFooter.
 */
export function useTotalRentCache(propertyGuid: string): number {
    return useApplicationCache(d =>
        d.information?.properties?.items
            ?.find(p => p.guid === propertyGuid)
            ?.rentalUnits?.reduce((sum, u) => sum + (u.rent ?? 0), 0) ?? 0
    ) ?? 0;
}
